import { Link } from "react-router-dom";
import { ArrowLeft, XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div data-testid="payment-cancel-page" className="mx-auto max-w-2xl px-4 py-20 text-center sm:px-8">
      <XCircle size={56} className="mx-auto text-terra" />
      <h1 className="mt-6 font-serif text-4xl font-semibold text-bark">Paiement interrompu</h1>
      <p className="mt-4 text-base text-bark-soft">
        Aucun souci : votre panier est resté au chaud. Vous pouvez reprendre votre commande quand vous voulez.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-4">
        <Link to="/boutique" data-testid="cancel-back-to-shop" className="inline-flex rounded-full bg-amber-deep px-7 py-3.5 font-medium text-white shadow-md shadow-amber-900/15 transition-all duration-200 hover:bg-honey active:scale-95">
          Retour à la boutique
        </Link>
        <Link to="/" data-testid="cancel-back-home" className="inline-flex items-center gap-2 rounded-full border-2 border-amber-700/30 px-7 py-3.5 font-medium text-amber-900 transition-all duration-200 hover:border-amber-deep hover:bg-amber-50">
          <ArrowLeft size={16} /> Accueil
        </Link>
      </div>
    </div>
  );
}
